import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Stack } from "@mui/material";
import useDocumentTitle from "../../../hooks/useDocumentTitle";
import { useGetInvoiceHandler } from "../dataHandlers/getInvoiceHandler";
import InvoiceForm from "../components/InvoiceForm";
import { useResubmitInvoiceHandler } from "../dataHandlers/resubmitInvoiceHandler";
import DocumentSkeletonForm from "../../../components/DocumentSkeletonForm";
import { usePermissions } from '../../../hooks/usePermissions';
import { UPDATE_PURCHASE_INVOICE, UPDATE_SALE_INVOICE } from '../../../constants/eInvoicePermissions';
import { useActionDeniedSnackbar } from '../../../hooks/useActionDeniedSnackbar';
export default function ResubmitInvoicePage({ isPurchase = false }) {
  useDocumentTitle("Resubmit invoice");
  const navigate = useNavigate();
  const { document_id } = useParams();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { invoice, isLoading } = useGetInvoiceHandler(document_id, isPurchase);
  const { loading, hasEInvoicePermission } = usePermissions();
  const showActionDeniedSnackbar = useActionDeniedSnackbar();

  const onInvoiceResubmitted = () => {
    navigate(isPurchase ? "/purchases?tab=invoices" : "/sales?tab=invoices");
  };

  const { onSubmit, error, isPending } = useResubmitInvoiceHandler({
    onSuccess: onInvoiceResubmitted,
    isPurchase,
  });

  useEffect(() => {
    if (loading) {
      return;
    }
    const updatePermission = isPurchase ? UPDATE_PURCHASE_INVOICE : UPDATE_SALE_INVOICE;
    if (!hasEInvoicePermission(updatePermission)) {
      showActionDeniedSnackbar();
      navigate(isPurchase ? '/purchases?tab=invoices' : '/sales?tab=invoices', { replace: true });
    }
  }, [isPurchase, loading, hasEInvoicePermission, showActionDeniedSnackbar, navigate]);


  useEffect(() => {
    if (!isPending && isSubmitting) {
      setIsSubmitting(false);
    }
  }, [isPending, isSubmitting]);

  const onResubmit = async (data) => {
    if (!invoice?.uuid) {
      return;
    }
    setIsSubmitting(true);
    const payload = {
      ...data,
      status: "active",
    };
    try {
      await onSubmit(payload, invoice.uuid);
    } finally {
      setIsSubmitting(false);
    }
  };

  const onCancel = () => {
    navigate(isPurchase ? "/purchases?tab=invoices" : "/sales?tab=invoices");
  };

  if (isLoading || !invoice) {
    return <DocumentSkeletonForm />;
  }

  return (
    <Stack direction="column" sx={{ mt: "-2rem" }}>
      <InvoiceForm
        onSubmit={onResubmit}
        onCancel={onCancel}
        initialData={invoice}
        isPurchase={isPurchase}
        isResubmit={true}
        apiErrors={error ?? {}}
        isLoading={isPending || isSubmitting}
      />
    </Stack>
  );
}
